import React from 'react';
import { ClientPromoBannerImageProps } from './types';

const DESKTOP_BANNER_URL =
  'https://storage.googleapis.com/portal-brokers-ciencuadras.firebasestorage.app/ayuda%20sismo/Desktop.png';

const MOBILE_BANNER_URL =
  'https://storage.googleapis.com/portal-brokers-ciencuadras.firebasestorage.app/ayuda%20sismo/Mobile.png';

export const ClientPromoBannerImage: React.FC<ClientPromoBannerImageProps> = ({
  desktopImageUrl = DESKTOP_BANNER_URL,
  mobileImageUrl = MOBILE_BANNER_URL,
  altText = 'Programa de apoyo y tasa especial Ciencuadras y Davivienda',
}) => {
  return (
    <div
      id="client-promo-banner-responsive-wrapper"
      className="w-full flex items-center justify-center overflow-hidden rounded-2xl shadow-sm bg-transparent"
    >
      <picture className="w-full flex items-center justify-center">
        {/* Desktop Source (PC / Tablets a partir de 768px) */}
        <source media="(min-width: 768px)" srcSet={desktopImageUrl} />
        {/* Mobile Source (Default / Pantallas menores a 768px) */}
        <img
          id="client-promo-banner-img"
          src={mobileImageUrl}
          alt={altText}
          referrerPolicy="no-referrer"
          loading="eager"
          className="w-full max-w-[1311px] h-auto object-contain mx-auto rounded-2xl select-none"
        />
      </picture>
    </div>
  );
};
